import { CIcon } from '~/icons/types'

export const ciCaravans: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.005 16.8h-2.269l-.29-7.78a5.363 5.363 0 0 0-5.36-5.165H3.456A2.96 2.96 0 0 0 .5 6.82v8.355A2.629 2.629 0 0 0 3.124 17.8h.613a2.506 2.506 0 0 0 5 0h12.275a.393.393 0 0 0-.012.06v1a.5.5 0 1 0 1 0v-1a.393.393 0 0 0-.012-.06h1.017a.5.5 0 0 0 0-1Zm-7.254 0h-3.157V7.688h3.157V16.8Zm1-2.49h2.892l.092 2.492h-2.984V14.31ZM2.069 5.433a1.95 1.95 0 0 1 1.387-.574h11.63a4.363 4.363 0 0 1 4.361 4.2l.158 4.253h-2.854V7.187a.5.5 0 0 0-.5-.5h-4.157a.5.5 0 0 0-.5.5v6.125H1.5V6.82a1.95 1.95 0 0 1 .569-1.387ZM2.5 16.68a1.63 1.63 0 0 1-1-1.5v-.862h10.1V16.8H8.606a2.5 2.5 0 0 0-4.739 0h-.743a1.631 1.631 0 0 1-.624-.12Zm3.737 2.462a1.518 1.518 0 1 1 0-3.037 1.518 1.518 0 0 1 0 3.037Z'
    },
    {
      d:
        'M3.7 11.918h5.71a.5.5 0 0 0 .5-.5v-4.23a.5.5 0 0 0-.5-.5H3.7a.5.5 0 0 0-.5.5v4.23a.5.5 0 0 0 .5.5Zm.5-4.23h4.71v3.23H4.2v-3.23Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'caravans',
  type: 'thin'
}
